import { GET_POSTS } from './constants';

export function loadPosts(category) {
  return dispatch => dispatch({
    type: GET_POSTS,
    request: {
      method: 'GET',
      endpoint: 'posts/',
      queryParams: {
        category
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux/Posts/actions.js